import React from 'react';
import styled from 'styled-components';

import { media } from '@peloton/styles';
import { gray1, slate1, gray5, divider2 } from '@engage/colors';
import { spaces } from '@engage/styles';
import { header5Large } from '@engage/typography';
import { ReloadButton } from '@members/buttons';
import { ClassesCopy, Classes, Cta, CtaCopy } from '@members/copy';
import ErrorIcon from '@members/icons/Error';

import type { ViewProps } from '../ConnectedOnDemandModal';
import BackButton from './BackButton';

const ErrorModal: React.FC<React.PropsWithChildren<ViewProps>> = ({
  closeModal,
  onReloadClick,
  classId,
}) => (
  <Container>
    <ButtonContainer>
      <StyledBackButton color={gray5} onClick={closeModal}>
        <CtaCopy id={Cta.Back} />
      </StyledBackButton>
    </ButtonContainer>
    <StyledErrorIcon width={42} />
    <Message>
      <ClassesCopy id={Classes.ErrorLoadingClass} />
    </Message>
    <ReloadButton onClick={() => onReloadClick(classId)}>
      <CtaCopy id={Cta.Reload} />
    </ReloadButton>
  </Container>
);

const StyledErrorIcon = styled(ErrorIcon)`
  display: none;
  margin-top: ${spaces.large}px;

  ${media.tablet`
    display: block;
  `}
`;

const ButtonContainer = styled.div`
  border-bottom: 1px solid ${divider2};
  display: block;
  position: absolute;
  height: 50px;
  top: 0;
  width: 100%;

  ${media.tablet`
    display: none;
  `}
`;

const StyledBackButton = styled(BackButton)`
  height: 100%;
`;

const Container = styled.div`
  align-items: center;
  background-color: ${gray1};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  ${media.tablet`
    height: auto;
    padding: ${spaces.large}px 0 ${spaces.huge}px;
  `}
`;

const Message = styled.p`
  ${header5Large}
  color: ${slate1};
  padding: 0 ${spaces.huge}px ${spaces.large}px;
  text-align: center;

  ${media.tablet`
    padding: ${spaces.large}px ${spaces.huge}px;
  `}
`;

export default ErrorModal;
